<template>
  <el-form-item :label="label"
                class="app-types-checkbox">
    <el-checkbox-group :value="value"
                       @input="emit">
      <el-checkbox :key="`type_${type.key}`"
                   :label="type.key"
                   class="type"
                   v-for="type in topTypes">
        {{ $t(`TYPES_CHECKBOX.${type.key}`) }}
        ({{ type.count }})
      </el-checkbox>

      <div v-if="otherTypes.length > 0">
        <el-collapse-transition>
          <div v-show="isOpenedOtherTypes">
            <el-checkbox :key="`type_${type.key}`"
                         :label="type.key"
                         class="type"
                         v-for="type in otherTypes">
              {{ $t(`TYPES_CHECKBOX.${type.key}`) }}
              ({{ type.count }})
            </el-checkbox>
          </div>
        </el-collapse-transition>
        <div class="more-btn">
          <el-button :icon="isOpenedOtherTypes ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                     @click="toggleOpenedOtherTypes"
                     circle
                     size="mini">
          </el-button>
        </div>
      </div>
    </el-checkbox-group>
  </el-form-item>
</template>

<script>
export default {
  name: 'AppTypesCheckbox',
  props: {
    label: {
      type: String,
      default: ''
    },
    types: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    split: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      isOpenedOtherTypes: false
    }
  },
  computed: {
    topTypes () {
      return this.types.slice(0, this.split)
    },
    otherTypes () {
      return this.types.slice(this.split)
    }
  },
  methods: {
    toggleOpenedOtherTypes () {
      this.isOpenedOtherTypes = !this.isOpenedOtherTypes
    },
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-types-checkbox {
  .type {
    display: block;
  }

  .more-btn {
    text-align: center;
  }
}
</style>
